/**
 * Settings Command Group
 * jai1 settings (alias: jai1 s)
 */
import { Command } from 'commander';
import { createSettingsInitCommand } from './init.js';
import { createSettingsSetCommand } from './set.js';
import { createSettingsGetCommand } from './get.js';
import { createSettingsShowCommand } from './show.js';

export function createSettingsCommand(): Command {
    const cmd = new Command('settings')
        .description('Project settings — manage .jai1/settings.yaml');

    cmd.addCommand(createSettingsShowCommand());
    cmd.addCommand(createSettingsInitCommand());
    cmd.addCommand(createSettingsSetCommand());
    cmd.addCommand(createSettingsGetCommand());

    // Default action: show settings
    cmd.action(async () => {
        const { createSettingsShowCommand: showCmd } = await import('./show.js');
        const show = showCmd();
        await show.parseAsync([], { from: 'user' });
    });

    return cmd;
}
